import RpcClass from "../../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.plm.services.BudgetingPlannerService';

import LocalDate from "../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../server/LocalTime.js";



class BudgetingPlannerService extends RpcClass{

    /**
     *  @class BudgetingPlannerService
     *  @alias module:src/server/com/silkplm/rpc/plm/services/BudgetingPlannerService.BudgetingPlannerService
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param budgetingPlannerPM {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     checkRangeSubSeasonToAlert(budgetingPlannerPM) {
            return RpcClass.rpcCall('/rpc/plm/services/budgeting-planner-service/check-range-sub-season-to-alert', [budgetingPlannerPM]);
    }
    /** 
     * @async
     * @param budgetingPlanner {module:src/server/com/silkplm/model/plm/BudgetingPlanner.BudgetingPlanner} 
     * @param categoryParentId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     createBudgetingPlannerSummaryLevelUpCategory(budgetingPlanner, categoryParentId) {
            return RpcClass.rpcCall('/rpc/plm/services/budgeting-planner-service/create-budgeting-planner-summary-level-up-category', [budgetingPlanner, categoryParentId]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     deleteAllBudgetingPlanners() {
            return RpcClass.rpcCall('/rpc/plm/services/budgeting-planner-service/delete-all-budgeting-planners', []);
    }
    /** 
     * @async
     * @param seasonId {string} 
     * @param categoryId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/BudgetingPlanner.BudgetingPlanner>}
     */
     findBudgetingPlannerBySeasonAndCategory(seasonId, categoryId) {
            return RpcClass.rpcCall('/rpc/plm/services/budgeting-planner-service/find-budgeting-planner-by-season-and-category', [seasonId, categoryId]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM[]>}
     */
     getAllBudgetingPlannerPMWithProduct() {
            return RpcClass.rpcCall('/rpc/plm/services/budgeting-planner-service/get-all-budgeting-planner-p-m-with-product', []);
    }
    /** 
     * @async
     * @param budgetingPlannerPMId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM[]>}
     */
     getAllBudgetingPlannerPMWithProductSummaryRow(budgetingPlannerPMId) {
            return RpcClass.rpcCall('/rpc/plm/services/budgeting-planner-service/get-all-budgeting-planner-p-m-with-product-summary-row', [budgetingPlannerPMId]);
    }
    /** 
     * @async
     * @param colFiltersSpecs {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM[]>}
     */
     getAllBudgetingPlannerPMWithProductWithFilters(colFiltersSpecs) {
            return RpcClass.rpcCall('/rpc/plm/services/budgeting-planner-service/get-all-budgeting-planner-p-m-with-product-with-filters', [colFiltersSpecs]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM[]>}
     */
     getBudgetingPlannerListPMSummaryRows() {
            return RpcClass.rpcCall('/rpc/plm/services/budgeting-planner-service/get-budgeting-planner-list-p-m-summary-rows', []);
    }
    /** 
     * @async
     * @param colFiltersSpecs {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM[]>}
     */
     getBudgetingPlannerListPMSummaryRowsWithFilters(colFiltersSpecs) {
            return RpcClass.rpcCall('/rpc/plm/services/budgeting-planner-service/get-budgeting-planner-list-p-m-summary-rows-with-filters', [colFiltersSpecs]);
    }
    /** 
     * @async
     * @param seasonId {string} 
     * @param supplierId {string} 
     * @param merchantFromOrder {string} 
     * @param PMFromOrder {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM[]>}
     */
     getFilteredBudgetingPlannerPmRecords(seasonId, supplierId, merchantFromOrder, PMFromOrder) {
            return RpcClass.rpcCall('/rpc/plm/services/budgeting-planner-service/get-filtered-budgeting-planner-pm-records', [seasonId, supplierId, merchantFromOrder, PMFromOrder]);
    }
    /** 
     * @async
     * @param seasonId {string} 
     * @param supplierId {string} 
     * @param merchantFromOrder {string} 
     * @param PMFromOrder {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM[]>}
     */
     getFilteredBudgetingPlannerPmRecordsForEveryUser(seasonId, supplierId, merchantFromOrder, PMFromOrder) {
            return RpcClass.rpcCall('/rpc/plm/services/budgeting-planner-service/get-filtered-budgeting-planner-pm-records-for-every-user', [seasonId, supplierId, merchantFromOrder, PMFromOrder]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/Season.Season[]>}
     */
     listSeasons() {
            return RpcClass.rpcCall('/rpc/plm/services/budgeting-planner-service/list-seasons', []);
    }
    /** 
     * @async
     * @param listOfBudgetingPlannersPM {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     saveBudgetingPlannerPM(listOfBudgetingPlannersPM) {
            return RpcClass.rpcCall('/rpc/plm/services/budgeting-planner-service/save-budgeting-planner-p-m', [listOfBudgetingPlannersPM]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.plm.services.BudgetingPlannerService';
metadata.__type_short__ = 'BudgetingPlannerService';
BudgetingPlannerService.prototype.__metadata__ = metadata;

BudgetingPlannerService.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/plm/services/BudgetingPlannerService */
export default BudgetingPlannerService

export { BudgetingPlannerService }
